import { useState } from "react";

function Books({ onSelectBook }) {
  const books = [
    { id: "ai-book", title: "Artificial Intelligence (Foundation) -The Stepping Stone" },
    { id: "u2u-internship-guide", title: "U2U Internship Reference Guide" },
    { id: "u2u-cyber-labs", title: "U2U Cybersecurity Labs Reference Book" },
    { id: "u2u-ai-labs", title: "U2U Artificial Intelligence Labs Reference Book" },
    { id: "u2u-ai-book2", title: "Artificial Intelligence and Machine Learning Made Simple" },
    { id: "u2u-ai-book3", title: "Build Artificial Intelligence Model in Simple Steps using Scikit Learn" },
    { id: "u2u-ai-book4", title: "Artificial Intelligence Simplified for everyone" },
    { id: "u2u-ai-book5", title: "Building Artificial Intelligence Models with PyTorch- A Practical Step By Step Guide"},
    { id: "u2u-ai-book6", title: "100 Artificial Intelligence Concepts Everyone Must Know"},
    { id: "u2u-ai-book7", title: "Building Artificial Intelligence Applications For The Real World"},
    { id: "u2u-cyberlabs-practical", title: "Cybersecurity Labs - Building Practical Cybersecurity Skills" },
    { id: "u2u-cybersmart", title: "Cybersmart A Practical Guide to Digital Safety" },
    { id: "u2u-cyber-essentials", title: "U2U Cybersecurity Essentials" }
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>📚 Select a Book</h2>

      <div style={styles.grid}>
        {books.map((book) => (
          <div key={book.id} style={styles.card}>
            <h3>{book.title}</h3>

            <button
              style={styles.btn}
              onClick={() => onSelectBook(book.id)}
            >
              ▶ Open Book
            </button>
          </div>
        ))}
      </div>
       <h2 style={styles.title}>📚 Select Audio Book</h2>
       <div class="book-card">
        <h3>Learn Cybersecurity (Foundation)</h3>
         <a
  href="https://open.spotify.com/show/3b45i4dZ8a38AOHXI6g3PJ?si=j982ffyLTuuH2_vWZ-Oe6A"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
       </div>
       <div class="book-card">
        <h3>Learn Artificial Intelligence (Foundation)</h3>
         <a
  href="https://open.spotify.com/show/1rfrGo65AtnayqEpkS8NfZ?si=lrhImAKjRAuRrNAzkd78Jg"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
       </div>
       <div class="book-card">
       <h3>Master Artificial Intelligence (Advanced)</h3>
    <a
  href="https://open.spotify.com/show/0SdKXqndHxw3PAwOAdmJCh?si=7RztXeknQuaxlisWbGRrTg"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
  <div class="book-card">
       <h3>Learn Space Technologies (Foundation)</h3>
    <a
  href="https://open.spotify.com/show/033eyTZNLE5dTwLw3QATbL?si=s2UG80H0TuG8YlI2c-Y6Mg"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Explore Software Tools</h3>
    <a
  href="https://open.spotify.com/show/033uUmqswWmOWrVCblJrBH?si=Bpb1047eQ_2DVD9OoVlcFw"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Learn Quantum Technologies(Foundation)</h3>
    <a
  href="https://open.spotify.com/show/3zDh1RZqpOySydaJK7kb9R?si=7FG0wOcPRHWUl2NpelMnnQ"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Data Engineering(Foundation)</h3>
    <a
  href="https://open.spotify.com/show/54k8gruvhAdTHdHJhZXsXq"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Block Chain(Foundation)</h3>
    <a
  href="https://open.spotify.com/show/54k8gruvhAdTHdHJhZXsXq"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Cloud Technologies(Foundation)</h3>
    <a
  href="https://open.spotify.com/show/54k8gruvhAdTHdHJhZXsXq"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Internet of Things(Foundation)</h3>
    <a
  href="https://open.spotify.com/show/54k8gruvhAdTHdHJhZXsXq"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Career & Leadership Development</h3>
    <a
  href="https://open.spotify.com/show/72kobjRJkgZcLcUblNMoji?si=H0kZqNmvQWSLULqamiLVew"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>Internships & Industry Connect</h3>
    <a
  href="https://open.spotify.com/show/033rdvnyzWYhn1wLc3o17p?si=hGF-w3W_SxyxZJx01Gbheg"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
<div class="book-card">
       <h3>U2U Technology Mentor Series</h3>
    <a
  href="https://open.spotify.com/show/033y2dFtwvrUOOB1qwGQk7?si=EAsUA6zWS06sbyJG1-b1IQ"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.btn}>
  Listen on Spotify</a>
</div>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    background: "#111",
    color: "#fff",
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
  },
  card: {
    background: "#1c1c1c",
    padding: "20px",
    borderRadius: "12px",
    textAlign: "center",
  },
  btn: {
    marginTop: "10px",
    padding: "10px 14px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    background: "#4caf50",
    color: "#fff",
    fontWeight: "bold",
  },
};

export default Books;